import { useQuery } from '@apollo/react-hooks';

import { MigratedRecentlyQuery } from './MigratedRecentlyQuery.graphql';

export const useMigratedRecently = (contentId: string) => {
	const { data, loading, error } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		MigratedRecentlyQuery,
		{
			variables: { contentId },
		},
	);

	if (loading || error) {
		return false;
	}

	return data?.content?.nodes?.[0]?.metadata?.frontend?.migratedRecently || false;
};
